import * as Yup from "yup";

const LEVEL_REGEX = /^level_(\d+)$/;

const resolveMessage = (message, t, options) =>
  typeof t === "function" ? t(message, options) : message;

const mapYupErrors = (error) => {
  if (!error) return {};
  if (Array.isArray(error.inner) && error.inner.length > 0) {
    return error.inner.reduce((acc, item) => {
      const path = item?.path;
      if (!path || acc[path]) return acc;
      acc[path] = item.message;
      return acc;
    }, {});
  }
  if (error.path) {
    return { [error.path]: error.message };
  }
  return {};
};

const getLevelNumber = (unitLevel) => {
  if (!unitLevel) return null;
  const match = LEVEL_REGEX.exec(unitLevel);
  if (!match) return null;
  const level = Number(match[1]);
  return Number.isFinite(level) && level > 0 ? level : null;
};

const buildSchema = ({ parentChoicesLength = 0, t } = {}) => {
  const message = (text, options) => resolveMessage(text, t, options);
  const parentCount = Number.isFinite(parentChoicesLength)
    ? parentChoicesLength
    : 0;

  return Yup.object({
    name: Yup.string().trim().required(message("Name is required")),
    code: Yup.string().trim().required(message("Unit Code is required")),
    unitLevel: Yup.string()
      .required(message("Unit Level is required"))
      .matches(LEVEL_REGEX, message("Unit Level is required")),
    region: Yup.string().required(message("Region is required")),
    country: Yup.string().required(message("Country is required")),
    parentId: Yup.string().nullable(),
  }).test(
    "parent-check",
    message("Select a parent unit"),
    function checkParent(value) {
      const level = getLevelNumber(value?.unitLevel);
      if (!level || level <= 1) return true;

      if (parentCount <= 0) {
        return this.createError({
          path: "parentId",
          message: message(
            "Create a Level {{level}} unit before adding this one.",
            {
              level: level - 1,
            },
          ),
        });
      }

      if (!value?.parentId) {
        return this.createError({
          path: "parentId",
          message: message("Select a parent unit"),
        });
      }

      return true;
    },
  );
};

export const validateOrganizationUnitForm = (form = {}, options = {}) => {
  const schema = buildSchema(options);
  try {
    schema.validateSync(form, { abortEarly: false });
    return {};
  } catch (error) {
    return mapYupErrors(error);
  }
};
